import {AbstractReactComponent, ff, i18n, Icon} from 'mc/lib';
import {Form, FormActions, FormBody} from 'mc/lib/form';
import {requireFields} from 'mc/lib/utils';
import React from 'react';
import {Alert, Button} from 'reactstrap';
import {propTypes, reduxForm, SubmissionError} from 'redux-form';
import {Api} from '../../api';

const validateRequiredFields = requireFields(['username']);

class PasswordRecoveryForm extends AbstractReactComponent {

    static formName = 'passwordRecovery';

    static propTypes = {
        ...propTypes,
    };

    static validate = values => {
        return validateRequiredFields(values);
    };

    onSubmit = data => {
        return Api.passwordRecovery(data.email).then(response => {
            if (response) {
                this.props.onComplete();
            } else {
                throw new SubmissionError({_error: i18n('passwordRecoveryForm.userNotExist')});
            }
        });
    };

    render() {
        const {error, handleSubmit, pristine, submitting, onClose} = this.props;
        return (
            <Form form={PasswordRecoveryForm.formName} onSubmit={handleSubmit(this.onSubmit)}>
                <FormBody>
                    <p>{i18n('passwordRecoverForm.info')}</p>
                    {error && <Alert color="danger">{error}</Alert>}
                    <ff.String name="email" label={false} type="email"  placeholder={i18n('passwordRecoveryForm.email')} autoComplete="off" required />
                </FormBody>
                <FormActions cancelButton={true} onClose={onClose}>
                    <Button color="primary" type="submit" disabled={pristine || submitting}>
                        {submitting ? <Icon icon="spinner" animation={Icon.animation.spin}/> : null} {i18n('passwordRecoveryForm.submit')}
                    </Button>
                </FormActions>
            </Form>
        );
    }
}

const formConfig = {
    form: PasswordRecoveryForm.formName,
    validate: PasswordRecoveryForm.validate
};

export default reduxForm(formConfig)(PasswordRecoveryForm);
